<template>
  <div class="page">
    <div class="content">
      <el-form class="searchBox">
        <el-row>
          <el-col :span="3">
            <el-form-item label="搜索" :label-width="'100px'">
              <el-input
                style="width: 150px; margin: 10px 10px 0 0"
                placeholder="搜索区域名称"
                prefix-icon="el-icon-search"
                v-model="keyword"
                @keyup.enter.native="clickSearch"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="门店" :label-width="'120px'">
              <!-- 门店 -->
              <el-select
                style="width: 110px; margin: 10px 10px 0 0"
                class="select"
                :value="shopId"
                @change="changeCurShopId"
                placeholder="请选择"
                size="mini"
              >
                <el-option
                  v-for="item in shops"
                  :key="item.shop_id"
                  :label="item.shop_name"
                  :value="item.shop_id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <resetBtn
              @reset="reset"
              style="width: 56px; display: inline-block; margin: 10px 60px"
            ></resetBtn>
          </el-col>
          <el-col style="text-align: right" :span="6">
            <el-button
            v-if="$buttonAuthority('xitong-housepeizhi-addCage')"
              type="warning"
              size="small"
              style="margin: 10px 200px"
              @click="dialogAddVisible = true"
              >新建</el-button
            >
          </el-col>
        </el-row>
      </el-form>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="shopName" label="门店"> </el-table-column>
        <el-table-column label="区域名称">
          <template slot-scope="scope">
            {{ scope.row.areaInfo.title }}
          </template>
        </el-table-column>
        <el-table-column label="区域位置">
          <template slot-scope="scope">
            {{ scope.row.cageAreaPositionName }}
          </template>
        </el-table-column>
        <el-table-column label="位置编号">
          <template slot-scope="scope">
            {{ scope.row.cageAreaPositionId }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="edit(scope.row)"
              :disabled="!$buttonAuthority('dingdan-saleOrder-changeStaff')"
              >修改名称</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <page
      :page="page.page"
      :total="page.total"
      @change="pageChange"
      style="padding: 12px 0"
    ></page>
    <!-- 新建 -->
    <el-dialog
      title="新建区域位置"
      :visible.sync="dialogAddVisible"
      width="30%"
      :before-close="handleClose"
      center
    >
      <el-form :model="form" label-width="80px">
        <el-form-item label="门店">
          <el-select
            v-model="form.shopId"
            style="margin-top: 10px"
            placeholder="请选择"
          >
            <el-option
              v-for="item in shops"
              :key="item.shop_id"
              :label="item.shop_name"
              :value="item.shop_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区域">
          <el-select
            v-model="form.cageAreaId"
            style="margin-top: 10px"
            placeholder="请选择"
          >
            <el-option
              v-for="item in areaList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="位置名称">
          <el-input
            v-model="form.name"
            style="width: 217px; margin-top: 10px"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="addPosition">提交</el-button>
        <el-button
          plain
          type="warning"
          @click="
            dialogAddVisible = false;
            form.cageAreaId = '';
          "
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog
      title="修改区域位置名"
      :visible.sync="dialogEditVisible"
      width="30%"
      :before-close="handleEditClose"
    >
      <div>
        <span style="margin-right: 15px">位置:</span>
        <el-input v-model="changeName" style="width: 217px"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="editPosition">确 定</el-button>
        <el-button plain type="warning" @click="dialogEditVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <div v-if="drawerStatus">
      <dialogEdit
        :areaObj="areaInfo"
        @submit="submit_drawerStatus"
      ></dialogEdit>
    </div>
  </div>
</template>
  
  <script>
import page from "../../components/page.vue";
import resetBtn from "../../components/resetBtn.vue";
import dialogEdit from "../huotiguanli/petHouse/dialog/dialog_peizhiEdit.vue";
import shopList from "../../util/shopList";
export default {
  components: { page, dialogEdit, resetBtn },
  data() {
    return {
      dialogAddVisible: false,
      dialogEditVisible: false,
      keyword: "",
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      areaList: [],
      areaEditInfo: null,
      shopId: this.$store.state.shopId,
      drawerStatus: false,
      value: "",
      tableData: [],
      cageAreaId: "",
      form: {
        shopId: this.$store.state.shopId,
        cageAreaId: "",
        name: "",
      },
      changeName: "",
      shops:shopList,
    };
  },
  computed: {},
  mounted() {
    this.getCagePosition();
    this.getCageArea();
  },
  methods: {
    // 修改位置
    editPosition() {
      let params = {
        shopId: this.areaEditInfo.shopId,
        cageAreaPositionId: this.areaEditInfo.cageAreaPositionId,
        cageAreaId: this.areaEditInfo.areaInfo.value,
        name: this.changeName,
      };
      console.log(params);
      let loading = this.$loading();
      this.$http
        .post(
          process.env.VUE_APP_Url_8000 + "/api/update/shop/cage/position",
          params
        )
        .then((res) => {
          loading.close();

          if (res.code == 0) {
            this.getCagePosition();
            this.dialogEditVisible = false;
          }
        });
    },
    // 创建位置
    addPosition() {
      if (this.$public.isNull(this.form.cageAreaId)) {
        this.$message({
          type: "error",
          message: "请选择区域",
        });
        return;
      }
      if (this.$public.isNull(this.form.name)) {
        this.$message({
          type: "error",
          message: "请添加位置名称",
        });
        return;
      }
      let loading = this.$loading();
      this.$http
        .post(
          process.env.VUE_APP_Url_8000 + "/api/add/shop/cage/position",
          this.form
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.form.cageAreaId = "";
            this.form.name = "";
            this.dialogAddVisible = false;
          }
        });
    },
    // dialogEditVisible=false
    handleEditClose(done) {
      this.dialogEditVisible = false;
      this.getCagePosition();
    },
    handleClose(done) {
      this.dialogAddVisible = false;
      this.form.cageAreaId = "";
      this.form.name = "";
    },
    // 页码改变
    pageChange(a) {
      this.page.page = a;
      this.getCagePosition();
    },
    // 重置
    reset() {
      this.keyword = "";
      this.page.page = 1;
      this.getCagePosition();
    },
    // 关键词搜索
    clickSearch() {
      this.page.page = 1;
      this.getCagePosition();
    },
    // 获取门店笼子区域位置
    getCageArea() {
      this.$http
        .get(process.env.VUE_APP_Url_8000 + "/api/cage/area/list")
        .then((res) => {
          this.areaList = res.data;
          this.$store.commit("set_areaList", this.areaList);
        });
    },
    // 获取门店笼子类型位置
    getCagePosition() {
      let params = {
        shopId: this.shopId,
        pageIndex: this.page.page,
        pageSize: this.page.pageSize,
        keyword: this.keyword,
        cageAreaId: this.cageAreaId,
      };
      this.$http
        .post(
          process.env.VUE_APP_Url_8000 + "/api/shop/cage/area/position/list",
          params
        )
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.data;
            this.page.total = res.data.count;
            console.log(res.data, "区域位置列表");
          }
        });
    },
    // 切换门店
    changeCurShopId(e) {
      this.shopId = e;
      this.page.page = 1;
      this.getCagePosition();
    },
    edit(row) {
      this.areaEditInfo = row;
      console.log(row);
      this.changeName = row.cageAreaPositionName;
      this.dialogEditVisible = true;
    },
    submit_drawerStatus() {
      this.drawerStatus = false;
    },
  },
};
</script>
  
  <style scoped lang="scss">
.page {
  ::v-deep .el-form-item__label {
    line-height: 60px;
  }
  .searchView {
    .tabLine {
      display: flex;
      .tabItem {
        width: 88px;
        box-sizing: border-box;
        line-height: 36px;
        text-align: center;
        border-right: 1px solid #f2f2f2;
        cursor: pointer;
        font-size: 14px;
        background-color: #fff;
        &.active {
          color: $mainColor;
        }
      }
    }
    .searchBox {
      border-top: 1px solid #f2f2f2;
    }
  }
  .content {
    padding: 0 0px;
    min-height: 600px;
    ::v-deep .el-form-item {
      margin-bottom: 0;
      .el-form-item__label {
        padding-right: 5px;
        font-size: 12px;
      }
    }
  }
}
</style>